export default __webpack_public_path__ + "static/media/c61c2a6a76dee49314bcbc79739d5ab8.8ae09be5.svg";